
export default () => {
    const searchButtons = document.querySelectorAll('.header__additionals__item[data-target="search"]');
    const headerOverlay = document.querySelector('.header__overlay');
    const searchCloseButton = document.querySelector('.header__search__close');
    const searchInput = document.querySelector('.header__search__input');
    let searchOpened = false;

    if (searchButtons.length === 0 || !searchCloseButton || !headerOverlay || !searchInput) return;

    searchButtons.forEach(searchButton => {
        searchButton.addEventListener('click', () => {
            document.querySelector('.header__search').classList.add('active');
            headerOverlay.classList.add('active');
            document.body.classList.add('body--no-scroll');
            window.setTimeout(() => searchInput.focus(), 20);
            searchOpened = true;
        });
    });
    [searchCloseButton, headerOverlay].forEach(el => el.addEventListener('click', () => {
        if(!searchOpened) return;
        document.querySelector('.header__search').classList.remove('active');
        headerOverlay.classList.remove('active');
        document.body.classList.remove('body--no-scroll');
        searchOpened = false;
    }));
    document.body.addEventListener('keyup', (e) => {
        if(e.key === 'Escape' && searchOpened) document.querySelector('.header__search__close').click();
    });

    initializeActiveInput();
    initializeSearchResults();
}

const initializeActiveInput = () => {
    const searchInput = document.querySelector('.header__search__input');
    if (!searchInput) return;
    searchInput.addEventListener('focus', () => {
        searchInput.parentNode.classList.add('active');
    })
    searchInput.addEventListener('blur', () => {
        searchInput.parentNode.classList.remove('active');
    })
}

const initializeSearchResults = () => {
    const searchInput = document.querySelector('.header__search__input');
    const searchResults = document.querySelector('.header__search__results');
    if (!searchInput || !searchResults) return;

    const searchResultsLoading = searchResults.querySelector('.header__search__results__loading');
    const searchResultsContainer = searchResults.querySelector('.header__search__results__container');

    let timeoutId;
    let controller;
    searchInput.addEventListener('input', () => {
        clearTimeout(timeoutId);
        if(searchInput.value.length >= 3){
            searchResultsLoading.classList.add('active');
            searchResultsContainer.classList.remove('active');

            timeoutId = setTimeout(() => {
                const params = new URLSearchParams({
                    q: searchInput.value,
                    isMobile: window.innerWidth < 992 ? 1 : 0
                });
                fetch(`/wp-json/moyamatcha/v1/search?${params}`)
                    .then(res => res.json())
                    .then(data => {
                        if(controller !== timeoutId) return;
                        searchResultsLoading.classList.remove('active');
                        searchResultsContainer.classList.add('active');
                        searchResultsContainer.innerHTML = data.html;
                    });
            }, 500);
            controller = timeoutId;
        } else{
            searchResultsContainer.innerHTML = '';
            searchResultsContainer.classList.remove('active');
            searchResultsLoading.classList.remove('active');
        }
     })
}